import { css } from "lit";

export const BasicInputTextAreaStyles = css`
    .input-group {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }
    
    input,
    textarea {
        padding: 12px 16px;
        border: 2px solid #e0e0e0;
        border-radius: 8px;
        font-size: 1rem;
        transition: all 0.3s ease;
        background: white;
        font-family: var(--font-text);
    }
    
    input:focus,
    textarea:focus {
        outline: none;
        border-color: #3b82f6;
        box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
    }
    
    textarea {
        resize: vertical;
        min-height: 80px;
    }
    
    label {
        font-family: var(--font-text);
        font-size: 1rem;
        color: black;
    }
    
    .helper-text {
        font-size: 0.85rem;
        color: #666;
        margin-top: 5px;
        font-family: var(--font-text);
    }
	input:disabled,
	textarea:disabled {
		background-color: #f5f5f5;
		cursor: not-allowed;
		opacity: 0.6;
	}`;